var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.8327H3C2.55 5.8327 2.25 5.54106 2.25 5.10361C2.25 4.66616 2.55 4.37452 3 4.37452H12C12.45 4.37452 12.75 4.66616 12.75 5.10361C12.75 5.54106 12.45 5.8327 12 5.8327ZM9.75 10.2072H5.25C4.8 10.2072 4.5 9.91558 4.5 9.47813C4.5 9.04068 4.8 8.74904 5.25 8.74904H9.75C10.2 8.74904 10.5 9.04068 10.5 9.47813C10.5 9.91558 10.2 10.2072 9.75 10.2072ZM14.25 1.45817H0.75C0.3 1.45817 0 1.16654 0 0.729087C0 0.291635 0.3 0 0.75 0H14.25C14.7 0 15 0.291635 15 0.729087C15 1.16654 14.7 1.45817 14.25 1.45817Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter_icon.af4e15a46cf2af7b4b91df5832a418e7.svg";
export { ForwardRef as ReactComponent };